import { createAction } from '@reduxjs/toolkit';

export type Notification = {
	message: string | JSX.Element;
	variant: 'success' | 'info' | 'error';
	autoDismissMs?: number;
};

export const showNotification = createAction<Notification>('Notifications/SHOW_NOTIFICATION');
export const dismissNotification = createAction<string>('Notifications/DISMISS_NOTIFICATION');
export const dismissAllNotifications = createAction('Notifications/DISMISS_ALL_NOTIFICATIONS');
